import { SpaceBlocking, SpaceBooking, SpaceGroup } from "components/SpaceBooking/types";
import { Moment } from "moment";
import React, { Children, createContext, useCallback, useContext } from "react";
import { useSWRConfig } from "swr";

interface RefetchContext {
    refetchAll: (data?: any) => void;
    refetchBooking: (booking: SpaceBooking) => void;
    refetchBlocking: (blocking: SpaceBlocking) => void;
}

const RefetchContext = createContext<RefetchContext>({
    refetchAll: () => {},
    refetchBooking: () => {},
    refetchBlocking: () => {},
});

export const useRefetchContext = () => useContext(RefetchContext);

interface Props {
    selectedDate: Moment;
    spaceGroup: SpaceGroup;
    children: any;
}

export const RefetchContextProvider = ({ selectedDate, spaceGroup, children }: Props) => {
    const { mutate } = useSWRConfig();
    const refetchAll = useCallback(
        () => mutate(`space/${spaceGroup?.id}/${selectedDate.year()}/${selectedDate.week()}`),
        [selectedDate, spaceGroup]
    );
    const refetchBlocking = useCallback(
        (blocking?: SpaceBlocking) => blocking && mutate(`space/blocking/${blocking.id}`, { data: blocking }),
        []
    );
    const refetchBooking = useCallback(
        (booking: SpaceBooking) => mutate(`space/booking/${booking.id}`, { data: booking }),
        []
    );

    return (
        <RefetchContext.Provider value={{ refetchAll, refetchBooking, refetchBlocking }}>
            {children}
        </RefetchContext.Provider>
    );
};
